import type { GeoTiffLoadSourceOptions } from "../../components/CreateLayer/GeoTiffBuilder";
import { getStats } from "../../vendor/geotiff-stats";
import GeoTIFF, { fromBlob, fromUrl, GeoTIFFImage } from "geotiff";

function isMask(image: GeoTIFFImage) {
  const fileDirectory = image.fileDirectory;
  const type = fileDirectory.NewSubfileType || 0;
  return (type & 4) === 4;
}
export async function getStatsForSource(source: GeoTiffLoadSourceOptions, selectedBands?: number[]) {
  try {
    console.log("stats read init", source);
    let geotiffFile: GeoTIFF | undefined;
    if (source.blob) {
      geotiffFile = await fromBlob(source.blob);
    } else if (source.url) {
      geotiffFile = await fromUrl(source.url);
    }
    if (!geotiffFile) throw new Error('geotiff not read');
    const imageCount = await geotiffFile.getImageCount();
    let image: GeoTIFFImage | undefined;
    // try to use highest resolution overview for stats -- find subimage that is not a mask
    console.log('starting index', imageCount - 1);
    for (let i = imageCount - 1; i >= 0; i--) {
      const _image = await geotiffFile.getImage(i);
      if (!isMask(_image)) {
        const size = Math.max(_image.getWidth(), _image.getHeight());
        if (image && size >= 512) break; // if image too big stop and already have one selected stop looking.
        image = _image;
      }
    }
    if (!image) throw new Error('no image found')
    const stats = await getStats(image, {
      calcStatsOptions: { filter: ({ value }: {value: number}) => isFinite(value) },
    }, selectedBands);
    return stats;
  } catch (e) {
    console.error(e);
  }
}
